export const EnergeticCertificate = () => {
    return(
        <div>
            Certificado Energético
        </div>
    )
}

// export const EnergeticCertificate = () => {  EN VERSION
//     return(
//         <div>
//             Energetic Certificate
//         </div>
//     )
// }